import DashboardHeader from "../../components/jefatura/DashboardHeader";
import DashboardTabs from "../../components/jefatura/DashboardTabs";
import { Container, Col, Row } from "react-bootstrap";
import { useState, createContext } from "react";

const styles = {
  container: {
    fontFamily: "var(--font-funcionarios)",
  },
};

// Contexto para compartir el período entre componentes
export const PeriodContext = createContext();

function Dashboard() {
  const [activeTab, setActiveTab] = useState("resumen");
  const [selectedPeriod, setSelectedPeriod] = useState("last_month");
  const [customDates, setCustomDates] = useState(null);

  return (
    <Container fluid className="p-0 m-0 w-100">
      <PeriodContext.Provider value={{ 
        selectedPeriod, 
        setSelectedPeriod, 
        customDates, 
        setCustomDates 
      }}>
        <Row className="g-3">
          <Col xs={12}>
            <DashboardHeader
              icon={<i className="bi bi-bar-chart-line"></i>}
              title="Panel de Estadísticas - Atención de Estudiantes"
              subtitle="Jefatura de Administración Docente"
              period={selectedPeriod !== "custom" ? selectedPeriod : null}
              startDate={customDates?.startDate}
              endDate={customDates?.endDate}
            />
          </Col>
          <Col xs={12}>
            <DashboardTabs
              activeTab={activeTab}
              onTabSelect={(key) => setActiveTab(key)}
            />
          </Col>
        </Row>
      </PeriodContext.Provider>
    </Container>
  );
}

export default Dashboard;
